import Body from '../../../../../atomic/atoms/Body';
import { SHARE_SHEET_MODAL } from '../../../../../languages/en/flows/builder';
import { Flex } from '../../../../../Utils/styles/display';
import {
  StyledShareSheetButton,
  StyledShareSheetSVGIcon,
  StyledShareSheetBody,
  StyledShareSheetSuffixSVGIcon,
} from '../styles';
import ThemeV2 from '../../../../../theme';

export const AdvancedShareSheetController = ({
  visibilityTitleContent,
  subtitleContent,
  handleChooseParticipants,
  handleChooseViewers,
  isSimplifiedShareSheetTreatmentOn,
}: {
  handleChooseParticipants: () => void;
  handleChooseViewers: () => void;
  visibilityTitleContent?: string;
  subtitleContent?: string;
  isSimplifiedShareSheetTreatmentOn: boolean;
}) => {
  return (
    <>
      {!isSimplifiedShareSheetTreatmentOn && (
        <>
          <Body variant="body1Bold" className="hello">
            {SHARE_SHEET_MODAL.FLOW_MEMBERS}
          </Body>
          <Body margin="0 0 16px 0" variant="body3">
            {SHARE_SHEET_MODAL.DESCRIPTION}
          </Body>
        </>
      )}
      <StyledShareSheetButton
        onClick={handleChooseParticipants}
        className="introjs-sharesheet-modal"
      >
        <Flex alignItems="flex-start">
          <StyledShareSheetSVGIcon
            icon="people"
            size="16px"
            color={ThemeV2.palette.geekBlue6}
          />
          <div>
            <StyledShareSheetBody variant="body1Medium">
              {SHARE_SHEET_MODAL.CHOOSE_PARTICIPANTS}
            </StyledShareSheetBody>
            <StyledShareSheetBody variant="body3">
              {subtitleContent}
            </StyledShareSheetBody>
          </div>
        </Flex>
        <StyledShareSheetSuffixSVGIcon icon="carat-right" size="20px" />
      </StyledShareSheetButton>
      <StyledShareSheetButton
        onClick={handleChooseViewers}
        className="introjs-sharesheet-participants"
      >
        <Flex alignItems="flex-start">
          <StyledShareSheetSVGIcon
            icon="eye"
            size="16px"
            color={ThemeV2.palette.geekBlue6}
          />
          <div>
            <StyledShareSheetBody variant="body1Medium">
              {SHARE_SHEET_MODAL.CHOOSE_VIEWERS}
            </StyledShareSheetBody>
            <StyledShareSheetBody variant="body3">
              {visibilityTitleContent}
            </StyledShareSheetBody>
          </div>
        </Flex>
        <StyledShareSheetSuffixSVGIcon icon="carat-right" size="20px" />
      </StyledShareSheetButton>
    </>
  );
};
